import styled from 'styled-components';
import { text2 } from '@ardoq/typography';
import { colors } from '@ardoq/design-tokens';
import { ArdoqIcon, getIcon, getIcons, getShapes } from '@ardoq/icons';

const EmptyCell = styled.div`
  ${text2};
  color: ${colors.textSubtle};
`;

export const NotApplicable = () => <EmptyCell>n/a</EmptyCell>;
export const NoValue = () => <EmptyCell></EmptyCell>;
export const Redacted = () => <EmptyCell>—</EmptyCell>;
export const PlaceholderValue = () => <EmptyCell>—</EmptyCell>;
export const graphics = {
  shapes: getShapes(),
  icons: { ...getIcons(), none: getIcon('') } as Record<string, ArdoqIcon>,
};
